import { render } from "./VPatientDetails.vue?vue&type=template&id=4b573da7"
import script from "./VPatientDetails.vue?vue&type=script&lang=js"
export * from "./VPatientDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__